import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import logo from "../images/logo.webp";
import "../CSS/Header.css";
import { Marketing_lead } from "./LeadMarketing";
import { useDispatch, useSelector } from "react-redux";
import { userLogout } from "../action/UserAction";
import { checkStatus } from "../core/common";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoggedin, setIsLoggedin] = useState(false);

  // const myGreeting="pls Re-join it's more than 10 hour"

  // const myTimeout = setTimeout(myGreeting, 5000);

  const { userInfo, exdt } = useSelector((s) => s.loginUsers);
  function Logout() {
    dispatch(userLogout());
    window.location.href = "/";
    // setTimeout(myGreeting, 5000);
    // setTimeout(myTimeout)

    //     let hours = 1
    //         let saved = sessionStorage.getItem('saved')
    //         if (saved && (new Date().getTime() - saved > hours * 60 * 60 * 1000)) {
    //         sessionStorage.clear();
    // }

    // useEffect(() => {
    //   const timeout = setTimeout(() => {
    //     // 👇️ redirects to an external URL
    //     window.location.replace('/');
    //   }, 3000);
    //   sessionStorage.clear();

    //   return () => clearTimeout(timeout);

    // }, []);
  }

  useEffect(() => {
    if (checkStatus()) {
      if (userInfo) {
        let dttt = new Date().getTime() - parseInt(exdt);
        if (parseInt(dttt) > 36000000 || parseInt(dttt) < 0 || !dttt) {
          navigate("/");
        }
      }
    } else {
      navigate("/");
    }
  }, [dispatch]);

  return (
    <>
      {/* <Navbar
        className="nav  navbar navbar-expand-md"
        bg="light"
        expand="xl"
        variant="light"
      >
        <Container fluid>
          <Navbar.Brand href="/">
            <img
              src={logo}
              width="120"
              height="50"
              className="d-inline-block align-top"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-2 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            >
              <NavDropdown title="Lead Marketing" id="navbarScrollingDropdown">
                <NavDropdown.Item href="/lead-marketing">
                  Lead Marketing
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/lead-marketing2">
                  Lead Marketing2
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown
                title="Application Details"
                id="navbarScrollingDropdown"
              >
                <NavDropdown.Item href="/application-details">
                  Applications Details
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/application-details2">
                  Application Details2
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/application-details3">
                  Application Details3
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Leads" id="navbarScrollingDropdown">
                <NavDropdown.Item href="/lead-details">
                  Lead Details
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="/leads-overview">
                  Lead Overview
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link href="/active-unique-details">
                Active Unique Details
              </Nav.Link>
              <Nav.Link href="/payment-made">Payment Made</Nav.Link>
              <Nav.Link href="/student-dropouts">Student Dropouts</Nav.Link>
              <Nav.Link href="/total-applicant-count">
                Total Applicant Count
              </Nav.Link>
              <Nav.Link href="/application-overview">
                Application Overview
              </Nav.Link>
              <Nav.Link href="/visa-details">Visa Details</Nav.Link>

              <Button variant="primary" size="sm" active onClick={Logout}>
                LogOut
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container> 

        
      </Navbar> */}
      <Button
        variant="primary"
        size="sm"
        active
        onClick={Logout}
        style={{ float: "right", margin: "25px" }}
      >
        LogOut
      </Button>
    </>
  );
}
